export const enumPermisosTuLlaveAdmin = Object.freeze({
  GESTION_DATAFONOS_TULLAVE: 27000,
});

export const enumPermisosTuLlave = Object.freeze({
  RECARGA_DATAFONOS_TULLAVE: 27001,
  RECARGA_TARJETAS_TULLAVE: 27002,
  CONSOLIDACION_TULLAVE: 27003,
});
